import React from "react";
import CatalogCard from "./CatalogCard";
import { useSelector } from "react-redux";
import LoadingView from "../../Utils/ViewWrapper/LoadingView/LoadingView";
import { useTranslation } from "react-i18next";

const NewCatalogueList = ({ activeTab, searchInput, productsactiveTab }) => {
  const { t } = useTranslation("common");
  const { catalogue, catalogueLoading } = useSelector(
    (state) => state.catalogueReducer,
  );

  if (catalogueLoading) {
    return (
      <div className="flex-grow-1">
        <LoadingView />
      </div>
    );
  }

  if (!catalogue || catalogue.length === 0) {
    return (
      <div className="flex-grow-1 d-flex">
        <p className="f18 text-dark">{t("No products found.")}</p>
      </div>
    );
  }

  return catalogue.map((product) => (
    <CatalogCard
      product={product}
      key={product.id}
      activeTab={activeTab}
      searchInput={searchInput}
      productsactiveTab={productsactiveTab}
    />
  ));
};

export default NewCatalogueList;
